import React from "react";
export function Logo({
  url,
  visible,
  size
}: {
  url?: string;
  visible?: boolean;
  size?: 'small' | 'medium' | 'large';
}) {
  if (!url || !visible) {
    return null;
  }
  const className = size === 'small' ? 'logo-small' : size === 'medium' ? 'logo-medium' : 'logo-large';
  return <img src={url} alt={"Logo"} className={className} data-sentry-component="Logo" data-sentry-source-file="Logo.tsx" />;
}